import TextField from '@mui/material/TextField';
import { useEffect, useState, useRef } from 'react'; 
import Skeleton from '@mui/material/Skeleton';
import { Typography } from '@mui/material';

const PageInputObjCopy = ({ tag, objKey, obj, setObj, width, font, showError, disableEdit=false, isLoading,hintText }) =>{
    // initialize state 
    const [value, setValue] = useState(''); 
    // initialize ref
    const ref = useRef();
    // set width if not given as prop
    if (width == null){
        width = '16.6vw';
    }
    // set font size if given as prop, else use default
    let style = {'fontFamily':"Roboto medium, Helvetica, Arial, sans-serif"};
    if (font){
        style['fontSize'] = font;
    } 

    // event handler for text field change
    const onChange = (e) => {
        setValue(value => value = e.target.value); 
        // update object at objKey
        let temp = obj; 
        temp[objKey] = e.target.value; 
        setObj(obj => obj = temp); 
        console.log(temp);
    }

    // handle showing error and setting focus
    const [error, setError] = useState(); 
    useEffect(() => {
        if (showError && showError == true) { 
            // set show error
            setError(error => error = true); 
            // focus on error element 
            ref.current.focus();
        }
        else {
            setError(error => error = false); 
        }
    }, [showError]); 

    // useEffect on obj change
    useEffect(() => {
        if (obj != null && obj[objKey] != null) {
            setValue(value => value = obj[objKey]); 
        }
        else {
            setValue(value => value = ''); 
        }
    }, [obj]); 

    // render page input 
    return (
        <>
            { isLoading ? 
            <>
                <Skeleton variant="rectangular" width='100%' height={'40px'} sx={{ borderRadius: '5px' }}/>
            </>
            : /* material ui textfield for text input */
            <div className={"d-flex width-fit-content align-items-center gap-3"}>
                <Typography fontSize={"14px"} className='align-self-center lh-24'>{tag}</Typography>
                <TextField 
                    sx={{ width: width, maxWidth: 450}} 
                    id="outlined-basic" 
                    size='small' 
                    placeholder={hintText} 
                    variant="outlined" 
                    value={disableEdit? (value !== (null || "") ? value : "None") : value} 
                    onChange={(e)=>{onChange(e)}}
                    inputProps={{style: style, readOnly: disableEdit}} // font size of input text
                    disabled = {disableEdit}
                    InputLabelProps={{style: style,}} // font size of input label
                    error={error}
                    inputRef={ref} 
                />
            </div>}
        </> 
    );
} 

export default PageInputObjCopy;